import React, { useState, useEffect } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';

import { apiPatch, apiGet, apiPost, getAccountsApiUrl, getBenefitsApiUrl, getAdminApiUrl, apiMessages } from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import { formatPhone, decodeValues } from '../common/Formats';
import Strings from  '../common/Strings';
import Pagination, { resetPaging } from '../common/Pagination';

import DisplayPans from './DisplayPans';

export default function RecipientPans(props) {

	let blankRecipient = {
		accountUuid: '',
		recipientIdentifier: '',
		email: '',
		firstname: '',
		lastname: '',
		middlename: '',
		mobilePhone: '',
		cardIssuanceCode: false,
		address1: '',
		address2: '',
		city: '',
		stateCode: '',
		zipcode: '',
		accountTypeId:''
	};
	
	let [recipient, setRecipient] = useState(blankRecipient);
	let [pans, setPans] = useState([]);
	let [pagingData, setPagingData] = useState(resetPaging());

	let { id, progId } = useParams();

	let [showSpinner, setSpinner] = useState(false);
	let [message, setMessage] = useState();

	let notNull = (value) => value ? value : '';
	let notEmpty = (value, defaultValue) => value ? value : defaultValue;

	// max available to print
	let getMaxPans = () => {
		if (recipient && recipient.maxPrintedPans)
			return recipient.maxPrintedPans;
		return 0;
	};

	let getRecipient = (id) => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/account/' + id;

		apiGet(url).then((resp) => {
			//console.debug(resp);
			let cloned = {...resp};
			cloned.middlename = notNull(resp.middlename).trim();
			cloned.address2 = notNull(resp.address2).trim();
			cloned.mobilePhone = formatPhone(resp.mobilePhone);

			setRecipient(cloned);

			getRecipientPans();

		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400 || err.status == 404){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	let defaultPrintAfterGen = {panId:0, pansLoaded:false, printAfter:true};
	let [printerAfterGen, setPrintAfterGen] = useState(defaultPrintAfterGen);

	useEffect( () => {
		if (printerAfterGen.printAfter && printerAfterGen.pansLoaded && (printerAfterGen.panId > 0)) {
			setTimeout( () => {
				let clickId = 'pan-print-' + printerAfterGen.panId;
				//console.log(clickId);
				let myElement = document.getElementById(clickId);
				if (myElement)
					myElement.click();
				setPrintAfterGen(defaultPrintAfterGen);
			}, 1000);
		}
	}, [printerAfterGen]);

	let getRecipientPans = () => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/pans?programId=' + progId + '&accountUuid=' + id;

		apiGet(url).then((resp) => {
			//console.debug(resp);
			setPans(resp);
			setPagingData(resetPaging());

			if (resp.length < 1)
				setMessage({text:'No printed pans available.',type:'warning'});

		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400 || err.status == 404){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally( () => {
			setSpinner(false);
			setPrintAfterGen({...printerAfterGen, pansLoaded:true});
		});
	}

	let [program, setProgram] = useState({bin:'', seriesNbr:'', firstNine:''});
	let getProgram = (uuid) => {
		setSpinner(true);
		let url = getAdminApiUrl() + '/programs/' + uuid;
		apiGet(url).then((resp) => {
			//console.debug(resp);
			setProgram({bin:resp.bin, seriesNbr:resp.seriesNbr, firstNine:resp.bin + '' + resp.seriesNbr});
		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally( () => setSpinner(false) );
	};

	useEffect( () => {
		getRecipient(id);
	}, []);

	useEffect( () => {
		if (recipient && recipient.programUuid) {
			getProgram(recipient.programUuid);
		}
	}, [recipient]);

	let genPan = () => {
		setSpinner(true);

		let body = {
			programId:progId,
			accountUuid:id
		};

		let url = getAccountsApiUrl() + '/pans';
		apiPost(url, body).then((resp) => {
			//console.debug(resp);
			setMessage({text:'A new Pan has been generated.'});
			getRecipient(id);

			if (printerAfterGen.printAfter)
				setPrintAfterGen({...printerAfterGen, panId:resp.panId});

		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400 || err.status == 404){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	const history = useHistory();
	let GoBack = () => history.goBack();
	let ViewRecipient = () => {
		return <a href='#' onClick={GoBack}>Back to Recipient</a>
	};

	let PanAssignForm = () => {
		let panForm = {
			pan:'',
			programId:progId
		};
		let [pan, setPan] = useState(panForm);
	
		let handleFieldChange = (event) => {
			const {id, value} = event.target;
			let cloned = {...pan, [id]:value};
			setPan(cloned);
		}

		let checkPanLength = (event) => {
			const {id, value} = event.target;
			let newValue = value.length == 10 ? program.firstNine + '' + value : value;
			let cloned = {...pan, [id]:newValue};
			setPan(cloned);
		}

		let reassignPan = (e) => {
			e.preventDefault();
	
			setSpinner(true);
			let thePan = pan.pan.length == 19 ? pan.pan : program.firstNine + '' + pan.pan;
			let url = getBenefitsApiUrl() + '/pans/' + thePan + "/" + recipient.accountUuid;
			//console.log(url);
	
			apiPatch(url, {program:progId}).then( resp => {
				let messageObject = {text:"PAN reassigned.",type:'successs'};
				setMessage(messageObject);
				//getRecipientPans();
				getRecipient(id);
				setPan(panForm);
	
			}).catch(err => {
				console.log(err);
				let messageObject = {text:Strings.error.general,type:'danger'};
				if (err.status == 404) {
					messageObject = {text:"The PAN entered was not found.", type:'danger'};
				} else if (err.status == 422) {
					messageObject = {text:"The PAN entered cannot be reassigned.", type:'danger'};
				} else if (err.status == 400) {
					messageObject = {text:"The PAN and recipient must be in the same program.", type:'danger'};
				}
				setMessage(messageObject);
			}).finally(() => setSpinner(false));
		};

		let disabledBtn = recipient.accountTypeId == '1' || getMaxPans() < 1;
		let checkStyle = {padding:".5em", cursor:'pointer'};
		let helpStyle = {marginLeft: ".5em"};

		let handlePrintAfterCheckbox = (event) => {
			const { value, checked } = event.target;
			setPrintAfterGen({...printerAfterGen, printAfter:checked});
		};
	
		return (<>
			<form onSubmit={reassignPan}>
				<div className="row">
					<div className="form-group required col-12 col-sm-3">
						<label className="asterisk-label" htmlFor="pan">Assign PAN</label>
						<input type="text" id="pan" className="form-control" value={pan.pan} onChange={handleFieldChange} onBlur={checkPanLength} required maxLength="19" pattern="([0-9]{19}|[0-9]{10})"/>
						<small className="form-text text-muted">Enter the last 10 or all 19 digits.</small>
					</div>
					<div className="form-group col-12 col-sm-2">
					<br/>
					<button className='btn btn-primary' id="btnReassign" disabled={disabledBtn}>Assign PAN</button>
					</div>
					<div className="form-group col-12 col-sm-3">
					<br/>
					<button type="button" className="btn btn-primary" onClick={genPan} disabled={disabledBtn} id="btnGenNew">Generate Printable PAN</button>
					<label style={checkStyle}>
						<input type="checkbox" title="Print after generation" value={1} checked={printerAfterGen.printAfter} disabled={disabledBtn} onChange={handlePrintAfterCheckbox} />
						<span style={helpStyle}>Print after generation</span>
					</label>
					</div>
				</div>
			</form>
		</>);
	};

	return (
		<>
		<Processing show={showSpinner}/>

		<h3>Recipient Pans</h3>
		<ViewRecipient />

		<table className="table table-bordered">
			<tbody>
				<tr>
					<th>Account ID</th>
					<th>Name</th>
					<th>Email</th>
					<th>Phone</th>
				</tr>
				<tr>
					<td>{recipient.recipientIdentifier}</td>
					<td>{recipient.firstname} {recipient.middlename} {recipient.lastname}</td>
					<td>{recipient.email}</td>
					<td>{recipient.mobilePhone}</td>
				</tr>
			</tbody>
		</table>

		<hr/>
		<br/>

		<PanAssignForm />

		<MessageTag message={message}/>

		<hr/>
		<DisplayPans pans={pans} pagingData={pagingData} setPagingData={setPagingData} statusSuccess={() => getRecipient(id)} setMessage={setMessage}/>

		</>
	)
}
